import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const bid = sp.get("booking_id");
  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-4 pt-16 pb-24 text-center">
        <XCircle className="w-16 h-16 text-red-500 mx-auto" />
        <h1 className="text-3xl font-display font-black mt-4">Payment cancelled</h1>
        <p className="text-slate-500 mt-2">No worries — your booking is still saved. You can pay later or at pickup.</p>
        {bid && <Link to={`/book/confirm/${bid}`} className="inline-block mt-6 px-5 py-2.5 rounded-md bg-[#1e1b4b] text-white font-semibold" data-testid="back-to-booking-cancel">Back to booking</Link>}
      </section>
    </PublicLayout>
  );
}
